import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=0bb0d47e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=0bb0d47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0d47e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb0d47e')) {
      api.createRecord('0bb0d47e', component.options)
    } else {
      api.reload('0bb0d47e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=0bb0d47e&scoped=true&", function () {
      api.rerender('0bb0d47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-277ZPZNvk99Jx/JS/teamMember.vue"
export default component.exports